<template>
  <div class="newspaper-container">
    <div class="image-wrapper" ref="imageWrapper">
      <img
        :src="props.newspaperImage"
        alt="报纸"
        id="newspaper"
        ref="newspaperImage"
        @load="initImageMap"
      />
      <map name="newspaper-map" v-if="areas.length > 0">
        <area
          v-for="(area, index) in areas"
          :key="index"
          :coords="scaledCoords(area.coords)"
          shape="poly"
          @click="handleAreaClick(area)"
          @mouseenter="handleAreaHover(index, true)"
          @mouseleave="handleAreaHover(index, false)"
          style="cursor: pointer"
        />
      </map>
      <!-- 悬停遮罩层 -->
      <div
        v-for="(area, index) in areas"
        :key="'hover-' + index"
        class="hover-overlay"
        :class="{ active: activeHoverIndex === index }"
        :style="getOverlayStyle(area)"
      ></div>
    </div>
  </div>
</template>

<script setup>
import { ref, onMounted, watch, computed } from "vue";
import { useRouter } from "vue-router";
const emits = defineEmits(["openInfo"]);
const props = defineProps({
  newspaperImage: {
    type: String,
    required: true,
  },
  articles: {
    type: Array,
    required: true,
  },
});

const router = useRouter();
const newspaperImage = ref(null);
const imageWrapper = ref(null);
const areas = ref([]);
const activeHoverIndex = ref(-1);
const scale = ref(1); //报纸对比原始宽度的倍数

const scaledCoords = (coords) => {
  const coordsArr = coords
    .map((coord) => Math.round(Number(coord) * scale.value))
    .join(",");
  return coordsArr;
};
// 初始化图像映射
const initImageMap = () => {
  if (!props.articles || props.articles.length === 0) return;
  // 转换坐标格式为适合图像映射的格式
  areas.value = props.articles.map((article) => {
    return {
      id: article.id,
      coords: formatCoords(article.coords),
    };
  });
  // 设置图像映射
  if (newspaperImage.value) {
    newspaperImage.value.useMap = "#newspaper-map";
  }
};
// // 在组件脚本部分
// const scaleCoords = (coords, scale = 1.2) => {
//   return coords
//     .split(",")
//     .map((coord) => Math.round(Number(coord) * scale))
//     .join(",");
// };
// 格式化坐标字符串
const formatCoords = (coordStr) => {
  const str = coordStr.toString();
  // 移除可能的空格并分割成数组
  let coords = str.replace(/\s/g, "").split(",");
  return coords;
};
// 获取遮罩层样式
const getOverlayStyle = (area) => {
  const coordArray = area.coords?.map(Number);

  // 计算多边形边界
  const left = Math.min(...coordArray.filter((_, i) => i % 2 === 0));
  const top = Math.min(...coordArray.filter((_, i) => i % 2 !== 0));
  const width = Math.max(...coordArray.filter((_, i) => i % 2 === 0)) - left;
  const height = Math.max(...coordArray.filter((_, i) => i % 2 !== 0)) - top;
  let htmlFont = parseFloat(
    window.getComputedStyle(document.documentElement).fontSize
  );
  return {
    left: `${(left * scale.value) / htmlFont}rem`,
    top: `${(top * scale.value) / htmlFont}rem`,
    width: `${(width * scale.value) / htmlFont}rem`,
    height: `${(height * scale.value) / htmlFont}rem`,
  };
};

// 处理区域点击事件
const handleAreaClick = (item) => {
  emits("openInfo", item);
};

// 处理悬停事件
const handleAreaHover = (index, isHovering) => {
  activeHoverIndex.value = isHovering ? index : -1;
};

// 监听文章数据变化
watch(
  () => props.articles,
  (newVal) => {
    if (newVal && newVal.length > 0) {
      initImageMap();
    }
  },
  { immediate: true }
);

// 确保图片加载后初始化
onMounted(() => {
  if (newspaperImage.value.complete) {
    initImageMap();
  }
  // 获取img元素
  const img = document.getElementById("newspaper");
  console.log("img", img);
  img.onload = function () {
    // console.log("原始宽度:", this.naturalWidth);
    const naturalWidth = this.naturalWidth; // 原始宽度
    const displayWidth = img.offsetWidth; // 显示宽度
    const scaleX = displayWidth / naturalWidth; // 宽度缩放比例
    scale.value = scaleX;
  };
});
</script>

<style scoped>
.newspaper-container {
  width: 100%;
  height: 100%;
}
.image-wrapper {
  display: flex;
  justify-content: center;
  align-content: center;
  position: relative;
  width: 100%;
  height: 100%;
}

.image-wrapper img {
  width: 38.5rem;
  height: auto;
  display: block;
}

.hover-overlay {
  position: absolute;
  background-color: transparent;
  transition: background-color 0.2s ease;
  pointer-events: none; /* 防止遮罩层阻挡鼠标事件 */
}

.hover-overlay.active {
  background-color: rgba(255, 0, 0, 0.2);
}
</style>